import React from 'react';

import { useSelector } from 'react-redux';

// Global companion to the per-request handling in axios-interceptor.js: when any
// request's PARTNER credential is rejected (401), the interceptor drops the dead
// token and flags authReducer.partnerSessionExpired. This banner then tells the
// user on EVERY page why partner/admin data stopped loading — no per-page wiring.
//
// Fixed to the bottom of the viewport like DirectEmployerDeprecationBanner: the
// .fixedHeaderLayout title/filter block is position:fixed with z-index 99 and
// overlays anything placed at the top of the content flow.
const styles = {
   bar: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1030,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '0.5rem 1.25rem',
      padding: '0.75rem 1.5rem',
      background: '#5c1a1a',
      borderTop: '3px solid #dc3545',
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.25)',
      color: '#fff',
   },
   title: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
   },
   message: {
      color: 'rgba(255, 255, 255, 0.85)',
   },
};

const PartnerSessionExpiredBanner = () => {
   const partnerSessionExpired = useSelector(
      (state) => !!state.authReducer?.partnerSessionExpired,
   );

   if (!partnerSessionExpired) {
      return null;
   }

   // Deliberately NOT dismissible: pages cannot load partner/admin data in this
   // state, and hiding the reason is how "No data available" tickets happen.
   return (
      <div style={ styles.bar } role='alert'>
         <span style={ styles.title }>
            Your partner session has expired
         </span>
         <span style={ styles.message }>
            Partner and Admin pages cannot load data until you sign in again.
         </span>
         <a
            href='/t/auth/login/jobcase'
            className='btn btn-rounded btn-danger btn-sm'
         >
            Sign in again
         </a>
      </div>
   );
};

export default PartnerSessionExpiredBanner;
